'use client'

import * as React from 'react'
import useBasePath from '@/hooks/use-base-path'
import { pathFunnel } from '@/app/payment/[academy]/[product]/(funnel)/step-path-names'
import { useRouter } from 'next/navigation'
import { useTracking } from '@/hooks/use-tracking'

export type StepHeaderProps = {
  currentStep: number
  totalStep: number
  title: string
}
const headers = {
  1: {
    currentStep: 1,
    totalStep: 3,
    title: 'Regístrate para empezar tu membresía',
  },
  2: {
    currentStep: 2,
    totalStep: 3,
    title: 'Completa tus datos',
  },
  3: {
    currentStep: 3,
    totalStep: 3,
    title: 'Datos pago',
  },
}

type HeaderStepProps = {
  step: number
}

export default function HeaderForm({ step }: HeaderStepProps): React.ReactElement {
  const path = useBasePath()
  const router = useRouter()
  const tracking = useTracking()

  const goBack = () => {
    tracking.trackEvent({
      eventName: 'return_from_payment',
      parameters: {},
    })
    router.push(`${path}/${pathFunnel.toStep2}`)
  }

  return (
    <div className="mb-4">
      <div className="flex flex-row justify-between">
        <p className="text-checkout-xs font-normal">
          PASO{' '}
          <span className="font-semibold">{headers[step].currentStep}</span> DE{' '}
          <span className="font-semibold">{headers[step].totalStep}</span>
        </p>

        {step === 3 && (
          <p
            onClick={goBack}
            className="text-checkout-l ml-auto cursor-pointer font-normal">
            Volver
          </p>
        )}
      </div>
      <p className="md:text-checkout-xxxl max-w-[360px] text-[25px] font-medium">
        {headers[step].title}
      </p>
    </div>
  )
}
